import {useEffect} from 'react';
import {useServices} from '@/model';
import {installSpacesCleanup} from './data/resources';

/** Services only: installed before restored credentials can retire an account. */
export function SpacesRuntime():null {
    const services=useServices();
    useEffect(()=>{installSpacesCleanup(services);},[services]);
    return null;
}
